var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login__form"},[_c('img',{staticClass:"login__logo",attrs:{"src":require("@/assets/logo.svg"),"alt":"recycle race"}}),_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }